<template>
  <v-row class="mt-3">
    <v-col
      cols="6"
      class="d-flex justify-space-around"
      :sm="parseInt(24/bottomscount)"
      :lg="parseInt(12/bottomscount)"
      v-for="(item, i) in getBottoms"
      :key="`${item.title}-basicstats-${i}`"
    >
      <basic-statistic v-bind="item">
        <v-icon
          small
          v-bind="item.info.icon.style"
          v-text="item.info.icon.value"
        />
        <span
          class="ml-2"
          v-html="item.info.text.value"
          v-bind="item.info.text.style"
        ></span>
        <div v-if="item.info.text.subtext !== undefined">
          {{ item.info.text.subtext }}
        </div>
      </basic-statistic>
    </v-col>
  </v-row>
</template>
<script>
import BasicStatistic from "@/components/BasicStatistic";
import { mapGetters } from "vuex";
export default {
  components: { BasicStatistic },
  data() {
    return {
       showingTasks: "View All",
       bottomscount:0,
       template:  {
          title: "eBay Fees",
          heading: "733.15",
          avatar: {
            icon: "insert_chart_outlined",
            style: {
              color: "cyan",
            },
            avatarStyle: { class: "neu-glow", size: 50 },
          },
          info: {
            icon: {
              value: "arrow_upward",
              style: {
                color: "teal accent-4",
              },
            },
            text: {
              value: `+19.00<sup>%</sup>`,
              style: {
                class: "teal--text text--accent-4",
              },
              subtext: "Over last Period",
            },
          },
        }
    };
  },
  computed: {
  ...mapGetters(["user","settings","formattedAmount","formattedNumber"]),
  getBottoms(){
    //console.log(this.user);
    //let bottoms=JSON.parse(this.user.d_charts.Bottoms);
    let bottoms=this.user.d_charts.Bottoms;
    this.bottomscount=bottoms.length
    //console.log(bottoms);
    let Bottoms=[];
    bottoms.forEach(e =>
      {
        this.template.title=e.title;
        this.template.heading=this.formattedAmount(e.heading);
        this.template.avatar.icon=e.icon;
        this.template.avatar.style.color=e.color;
        this.template.info.icon.value=e.info_icon;
        this.template.info.icon.style.color=e.info_icon_color;
        this.template.info.text.value=parseFloat(e.text_value).toFixed(2)+`<sup>%</sup>`;
        Bottoms.push(JSON.parse(JSON.stringify(this.template)));
      }
    );
    return Bottoms;
  },
},
  beforeDestroy() {
    this.basicStatisticArr = null;
    delete this.basicStatisticArr;
  },
};
</script>
